import { F0Box } from '@factorialco/f0-react'
import { IndicatorsList, Widget } from '@factorialco/f0-react/dist/experimental'
import i18n from 'modules/core/lib/i18n'
import type { IncentivesCompensationPlanPeriodFragment } from 'generated/resources/graphql'
import moment from 'moment'
import { diffBetweenDates, formatBackendDateToDayMonthYear } from 'modules/core/lib/dates'
import { PERIOD_STATUS, getPeriodStatus } from 'modules/incentives/lib/period'

interface PlanDetailWidgetsProps {
  period: IncentivesCompensationPlanPeriodFragment
}

export function CompensationPlanDetailWidgets({ period }: PlanDetailWidgetsProps) {
  const periodStatus = getPeriodStatus(period)
  const widgetTitle =
    periodStatus === PERIOD_STATUS.CLOSED ? '' : i18n.t('incentives.detail.period_widget.title')
  const deadline = i18n.t('incentives.detail.period_widget.deadline', {
    date: formatBackendDateToDayMonthYear(period.endsOn),
  })
  const daysRemaining = diffBetweenDates(period.endsOn, moment().format('YYYY-MM-DD'))
  const daysLabel = `${daysRemaining} ${i18n.tp('common.day', { count: daysRemaining })}`
  const content =
    periodStatus === PERIOD_STATUS.CLOSED
      ? i18n.t('incentives.detail.period_widget.closed')
      : daysLabel

  return (
    <F0Box display="grid" width="1/2" marginLeft="lg">
      <Widget
        fullHeight
        key={'period-widget'}
        {...(widgetTitle ? { header: { title: widgetTitle } } : {})}
      >
        <IndicatorsList items={[{ content: content, label: deadline }]} />
      </Widget>
    </F0Box>
  )
}
